// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._kKAkqgkcS82dgLL254G{width:532px;max-width:100%}.eYpQjqCOWY4WxcfEG0D2{height:100%;margin-top:24px;overflow:auto}.gNm3laLTt0ctPoRfvikQ{margin-bottom:40px}._BMYvZWxH2Qkr0KT8s2Z{margin-bottom:8px;padding-left:12px}.RJ79pwjWxBcj3P47_tFR{padding-left:12px}.BTXDkcUmVz032E41Y11n{margin-top:7px;margin-left:1px}.h8oNrIB0vzoWrmElBj2e{margin:0 -2px}.oEUSqx2s2FAaKTZlIcxZ{padding-left:12px}.W9Q4WUeNgUiv5y4TatwU{background:var(--background-primary-Inverted-primary);color:var(--content-primary-tertiary);text-align:center;padding:22px 0;font-size:12px;font-style:normal;font-weight:400}.W9Q4WUeNgUiv5y4TatwU>button{padding:0!important}.W9Q4WUeNgUiv5y4TatwU>button:hover{background-color:var(--background-primary-Inverted-primary)!important}.lQKdRhYkmobDOd2pH5bp{color:var(--light-blue-60)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_kKAkqgkcS82dgLL254G`,
	"einFieldContainer": `eYpQjqCOWY4WxcfEG0D2`,
	"bannerWrap": `gNm3laLTt0ctPoRfvikQ`,
	"textFieldWithLabelInput": `_BMYvZWxH2Qkr0KT8s2Z`,
	"zipCodeInput": `RJ79pwjWxBcj3P47_tFR`,
	"noHaveEinButton": `BTXDkcUmVz032E41Y11n`,
	"searchIcon": `h8oNrIB0vzoWrmElBj2e`,
	"textInput": `oEUSqx2s2FAaKTZlIcxZ`,
	"noResultsMessage": `W9Q4WUeNgUiv5y4TatwU`,
	"enterManuallyButton": `lQKdRhYkmobDOd2pH5bp`
};
export default ___CSS_LOADER_EXPORT___;
